import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
    },
    emptyText: {
      fontStyle: 'italic',
      color: theme.palette.text.disabled,
    },
  }),
);

export default useStyles;
